import { useEffect } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import { Layout } from '@components';
import Container from '@components/Container';
import CategoryCard from '@components/UsedInventory/CategoryCard';
// import ProductSearchHeader from '@components/UsedInventory/ProductSearchHeader';
import { reqUsedCollectionAction } from '@stores/used/actions';
import { useUsedSelector } from '@stores/used/selectors';
// import { useProductCount } from '@helpers/product';
import styles from './UsedInventory.module.scss';

const SearchPage = () => {
  const dispatch = useDispatch();
  const categories = useSelector(useUsedSelector);
  // const productCount = useProductCount();

  useEffect(() => {
    dispatch(reqUsedCollectionAction());
  }, []);

  return (
    <Layout>
      <Container>
        <div className={styles.used__inventory__wrapper}>
          {/* <ProductSearchHeader productCount={productCount} /> */}
          <div className={styles.flex__grid}>
            {!isEmpty(categories) && (
              <>
                {categories.map((category, index) => (
                  <CategoryCard
                    category={category}
                    index={index}
                    key={`category-block-${index}`}
                  />
                ))}
              </>
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'footer'])),
    },
  };
};

export default SearchPage;
